import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            const u = await login(username.trim(), password);
            if (u && Number(u.must_change) === 1) {
                nav("/change-password", { replace: true });
                return;
            }
            const target = (loc.state && loc.state.from) || "/";
            nav(target, { replace: true });
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "login_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="min-h-screen grid place-items-center px-4">
            <div className="card w-full max-w-xl overflow-hidden">
                <div className="cardHeader">
                    <div className="text-text-100 font-extrabold text-2xl">Přihlášení</div>
                    <div className="text-text-300 mt-2">Přístupové údaje ti vytváří admin</div>
                </div>

                <div className="cardBody">
                    <form onSubmit={onSubmit} className="space-y-6">
                        <div>
                            <div className="label">Uživatelské jméno</div>
                            <input value={username} onChange={(e) => setUsername(e.target.value)} className="input mt-3" autoComplete="username" />
                        </div>

                        <div>
                            <div className="label">Heslo</div>
                            <input value={password} onChange={(e) => setPassword(e.target.value)} className="input mt-3" type="password" autoComplete="current-password" />
                        </div>

                        {err ? (
                            <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                                <div className="text-text-100 font-semibold">Nepřihlášeno</div>
                                <div className="text-text-200 text-sm mt-1">{err}</div>
                            </div>
                        ) : null}

                        <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed w-full" : "btnPrimary w-full"}>
                            {busy ? "Přihlašuji" : "Přihlásit"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
